module.exports = __webpack_public_path__ + "static/img/page67.93b7a66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page67.jpg
// module id = 9Ay5
// module chunks = 0